module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/common-module/components/multi-selection-bar/multi-selection-bar.component.scss
// module id = ./src/app/modules/common-module/components/multi-selection-bar/multi-selection-bar.component.scss
// module chunks = 9